
import { STALE_STYLE, staleness } from '@/features/plans/lib/staleness'

export function StalenessChip({ priorSerial, currentSerial }: { priorSerial: number | null; currentSerial: number | null | undefined }) {
  const s = staleness(priorSerial, currentSerial)
  return (
    <span className="badge" style={{ fontSize: '0.58rem', color: STALE_STYLE[s.tone].color, borderColor: STALE_STYLE[s.tone].border }}>
      {s.label}
    </span>
  )
}
